import type { EmergencyOnAzure } from '../../../generated-client/models/EmergencyOnAzure';
import type { EmergencyMessage } from './EmergencyMessage';
import type { UserLocation } from '../User/UserLocation';
import type { EmergencyMessageOnAzure } from '../../../generated-client/models/EmergencyMessageOnAzure';
import type { UserLocationOnAzure } from '../../../generated-client/models/UserLocationOnAzure';
import { Emergency } from './Emergency';

export type EmergencyLike = Emergency | EmergencyOnAzure | null | undefined;
export type EmergencyMessageLike = EmergencyMessage | EmergencyMessageOnAzure;
export type UserLocationLike = UserLocation | UserLocationOnAzure;

export interface AllEmergencyObjectsParams {
  emergency: EmergencyLike;
  emergency_messages: EmergencyMessageLike[];
  locations: UserLocationLike[];
}

/**
 * Represents a bundle of all data related to a single emergency.
 */
export class AllEmergencyObjects {
  public emergency: Emergency | null;
  public emergency_messages: EmergencyMessageLike[];
  public locations: UserLocationLike[];

  constructor({ emergency, emergency_messages, locations }: AllEmergencyObjectsParams) {
    this.emergency = emergency
      ? emergency instanceof Emergency
        ? emergency
        : new Emergency(emergency)
      : null;

    this.emergency_messages = emergency_messages;
    this.locations = locations;
  }
}
